import Paragraph from "@tiptap/extension-paragraph";
import type { Node as ProseMirrorNode } from "@tiptap/pm/model";

const NBSP = String.fromCharCode(0xa0);

interface MarkdownState {
  write(content: string): void;
  closeBlock(node: ProseMirrorNode): void;
  renderInline(node: ProseMirrorNode): void;
}

export const SpacerParagraph = Paragraph.extend({
  addStorage() {
    return {
      markdown: {
        serialize(
          state: MarkdownState,
          node: ProseMirrorNode,
          parent: ProseMirrorNode | null,
          index: number
        ) {
          const isEmpty = node.content.size === 0;
          const isTrailing = parent ? index === parent.childCount - 1 : false;
          if (isEmpty && !isTrailing) {
            state.write(NBSP);
            state.closeBlock(node);
            return;
          }
          state.renderInline(node);
          state.closeBlock(node);
        },
        parse: {},
      },
    };
  },
});
